import React from "react";
import "./HeaderContent.css";

const HeaderContent = () => {
  return (
    <div className="header_content-container">
      <div className="header_content-container--text">
        Providing Special Care <br /> <span>For Your Pets</span>
        <p>
          Excellent pets deserve excellent care. We are always fully <br />
          focused on helping your pet and you to overcame any hurdle.
        </p>
      </div>
    </div>
  );
};

export default HeaderContent;
